import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

import { useDispatch, useSelector } from 'react-redux';
import {
  cadastroProduct,
  resetProduct,
  getCategoriasProduto,
  getMarcas,
  products,
  patchProduct,
} from '../../../slices/productSlice';
import { getCategoria } from '../../../slices/getCategoria';
import Title from '../../../components/Title';
import InputGlobal from '../../../components/InputGlobal';
import ButtonGlobal from '../../../components/ButtonGlobal';
import SelectGlobal from '../../../components/SelectGlobal';
import TextAreaGlobal from '../../../components/TextAreaGlobal';
import ButtonImgUpload from '../../../components/ButtonImgUpload';
import MsgSucess from '../../../components/MsgSucess';
import Main from '../../../components/Main/Main';
import { useErroControlManul } from '../../../hook/useErroControlManul';
import Form from '../../../components/Main/Form';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import SelectTagMui from '../../../components/MarcasTag/SelectTagMui';
import CategoriaSelect from '../../../components/SelectComponents.jsx/CategoriaSelect';
import usePageTitle from '../../../hook/usePageTitle';
import useProductHook from '../../../hook/product';
import { Typography } from '@material-tailwind/react';

const editEstoque = (tipoEstoque) => {
  switch (tipoEstoque) {
    case 'Estoque':
      return 'estq';
    case 'Direta':
      return 'apc';
    case 'Descontinio':
      return 'und';
  }
};

export const estoque = [
  { id: 'estq', nome: 'Estoque' },
  { id: 'apc', nome: 'Direta' },
  { id: 'und', nome: 'Descontinio' },
];
export const undMedida = [
  { id: 'UND', nome: 'UND' },
  { id: 'MT', nome: 'MT' },
  { id: 'KG', nome: 'KG' },
];

export const criticidade = [
  { id: 'A', nome: 'Alta' },
  { id: 'B', nome: 'Media' },
  { id: 'C', nome: 'Baixa' },
];

const ProdutoEdit = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { error, success, marcas, loading } = useSelector((produto) => produto.product);
  const { isSuper } = useSelector((produto) => produto.auth);
  const { categoriasCompra } = useSelector((produto) => produto.categorias);
  const { useArrayErrorForm } = useErroControlManul();
  const navigate = useNavigate();
  const { getProdutos, produto, resetProduto } = useProductHook();

  const { id } = useParams();
  document.title = `Editar | ${produto?.nome || ''}`;

  useEffect(() => {
    if (id) {
      getProdutos(id);
    } else {
      reset();
      resetProduto();
    }
  }, [id]);

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    control,
    clearErrors,
    setError,
    watch,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (produto && !produto.error) {
      reset({
        nome: produto?.nome,
        winthor: produto?.winthor,
        endereco: produto?.endereco,
        quantidade_total: produto?.quantidade_total,
        tipoEstoque: editEstoque(produto?.tipoEstoque),
        unidadeMedida: produto?.unidadeMedida,
        criticidade: produto?.criticidade,
        descricao: produto?.descricao,
        marcaDeCompra: produto?.marcaDeCompra,
        categoria: produto?.categoria?.id.toString() || '',
        estoqueMinimo: produto?.estoqueMinimo,
        estoqueMaximo: produto?.estoqueMaximo,
        motivoDeCompra: produto?.motivoDeCompra,
      });
    }
  }, [produto]);

  const nomeWatch = watch('nome');

  useEffect(() => {
    dispatch(resetProduct());
    dispatch(getCategoriasProduto());
    dispatch(getMarcas());
    dispatch(getCategoria());
    return () => dispatch(resetProduct());
  }, [dispatch]);

  const resetInfo = () => {
    dispatch(resetProduct());
    dispatch(products());
    reset();
    if (produto) {
      navigate('/');
    }
  };

  useEffect(() => {
    if (error) {
      useArrayErrorForm(error, setError);
    }
    return () => clearErrors();
  }, [setError, error]);

  const onSubmit = (data) => {
    const formData = new FormData();
    if (data.foto?.length === 1) {
      formData.append('foto', data.foto[0]);
    }
    formData.append('nome', data.nome);
    formData.append('winthor', data.winthor);
    if (isSuper) {
      formData.append('quantidade_total', data.quantidade_total);
    }
    formData.append('endereco', data.endereco);
    formData.append('tipoEstoque', data.tipoEstoque);
    formData.append('unidadeMedida', data.unidadeMedida);
    formData.append('criticidade', data.criticidade);
    formData.append('descricao', data.descricao);
    formData.append('estoqueMinimo', data.estoqueMinimo);
    formData.append('estoqueMaximo', data.estoqueMaximo);
    formData.append('motivoDeCompra', data.motivoDeCompra);
    console.log(data);
    if (data.categoria > 0) {
      formData.append('categoria', data.categoria || '');
    }
    if (data.marcaDeCompra?.length > 0) {
      if (produto) {
        dispatch(
          patchProduct({
            formData,
            marcaDeCompra: data.marcaDeCompra.map((item) => item.id),
            id: produto.id,
          })
        );
      } else {
        dispatch(
          cadastroProduct({
            formData,
            marcaDeCompra: data.marcaDeCompra.map((item) => item.id),
          })
        );
      }
    } else {
      if (produto) {
        dispatch(patchProduct({ formData, id: produto.id }));
      } else {
        dispatch(cadastroProduct(formData));
      }
    }
  };
  return (
    <Main>
      <Title>Cadastrar Produto</Title>
      <Form>
        <div className="w-[80%] sm:w-[90%] md:w-[50%] sm:px-5 md:px-0">
          <InputGlobal
            type="text"
            label="nome"
            formCamp="nome"
            placeholder="Nome do produto"
            register={register}
            validations={{ required: true }}
            required={true}
            errors={errors?.nome ? errors : false}
          />
        </div>
        <div className="flex gap-1 flex-wrap flex-auto w-[90%] md:w-[50%] px-5 md:px-0">
          <InputGlobal
            formCamp="winthor"
            type="number"
            label="Codigo"
            placeholder="Codigo Winthor"
            register={register}
            validations={{ required: true }}
            required={true}
            errors={errors?.winthor ? errors : false}
            error={error}
          />
          <InputGlobal
            formCamp="endereco"
            type="text"
            label="Local"
            placeholder="Local Armazenado"
            register={register}
            errors={errors?.endereco ? errors : false}
            onError={!!(errors?.endereco || error?.endereco)}
            error={error}
          />
          <InputGlobal
            formCamp="quantidade_total"
            type="number"
            label="Quantidade"
            placeholder="Quantidade total"
            register={register}
            errors={errors?.quantidade_total ? errors : false}
            setValue={setValue}
            onError={!!(errors?.quantidade_total || error?.quantidade_total)}
            defaut={'0'}
            error={error}
            disabled={!isSuper}
          />
        </div>
        <div className="flex gap-y-5 gap-x-2 flex-wrap flex-auto w-[90%] px-5 md:px-0 md:w-[50%]">
          <CategoriaSelect
            // Categoria de compra
            categoriasCompra={categoriasCompra}
            control={control}
            errors={!!errors?.categoria}
          />

          <SelectGlobal
            defaut={'estq'}
            formCamp="tipoEstoque"
            label="Tipo estoque"
            array={estoque}
            errors={!!errors.tipoEstoque ? errors : false}
            control={control}
          />
          <SelectGlobal
            defaut={'UND'}
            formCamp="unidadeMedida"
            label="Unidade Medida"
            array={undMedida}
            errors={!!errors.unidadeMedida ? errors : false}
            control={control}
          />
          <SelectGlobal
            defaut={'B'}
            label="Criticidade"
            formCamp="criticidade"
            array={criticidade}
            errors={!!errors.criticidade ? criticidade : false}
            control={control}
          />
        </div>
        <SelectTagMui marcas={marcas} control={control} />
        <TextAreaGlobal text="Descricão" formCamp="descricao" register={register} />
        <div className="flex gap-y-5 gap-x-2 flex-wrap flex-auto w-[90%] px-5 md:px-0 md:w-[50%]">
          <InputGlobal
            formCamp="estoqueMinimo"
            type="number"
            label="Estoque Minimo"
            placeholder="Estoque Minimo"
            register={register}
            errors={errors?.estoqueMinimo ? errors : false}
            setValue={setValue}
            onError={!!(errors?.estoqueMinimo || error?.estoqueMinimo)}
            defaut={'0'}
            error={error}
            disabled={!isSuper}
          />
          <InputGlobal
            formCamp="estoqueMaximo"
            type="number"
            label="Compra Ideal"
            placeholder="Estoque Ideal"
            register={register}
            errors={errors?.estoqueMaximo ? errors : false}
            setValue={setValue}
            onError={!!(errors?.estoqueMaximo || error?.estoqueMaximo)}
            defaut={'0'}
            error={error}
            disabled={!isSuper}
          />
        </div>
        <TextAreaGlobal text="Motivo" formCamp="motivoDeCompra" register={register} />
        <ButtonImgUpload
          formCamp="foto"
          register={register}
          setValue={setValue}
          reset={!!success}
        />
        <div className="m-auto">
          <ButtonGlobal
            text={
              produto
                ? loading
                  ? 'Salvando'
                  : 'Salvar'
                : loading
                ? 'Cadastrando'
                : 'Cadastrar Produto'
            }
            click={handleSubmit(onSubmit)}
            error={Object.keys(errors).length > 0 ? true : false}
            loading={loading}
          />
        </div>
        {success && (
          <MsgSucess
            text={nomeWatch}
            reset={resetInfo}
            outText={produto ? 'Salvo com sucesso' : ''}
          />
        )}
      </Form>
    </Main>
  );
};

export default ProdutoEdit;
